export const config = {
  //API_BASE_URL: 'http://localhost:3001',
  API_BASE_URL: 'https://backend.buildup.am',
  CDN_BASE_URL: 'https://d34rq7yialevbd.cloudfront.net',
}
